import React, { useState, useEffect } from "react";
import { Grid, CircularProgress, Box } from "@material-ui/core";

import { HazardsAssessmentWithTabs } from "./HazardsAssessment";
import { RiskAssessmentMap } from "../riskAssessment/RiskAssessmentMap";
import { getHazardsByUserAndPage } from "../riskAssessment/hazardUtils";
import { LocationRiskAssessment } from "../riskAssessment/hazardIdEnum";
import { HazardProvider } from "../riskAssessment/HazardMapContext";

import { RiskRoofCard } from "./RiskRoofCard";
import { emptyGeojson } from "./defaultSourceLayer";
import { LngLat } from "mapbox-gl";
import { useClientConfig } from "../../context/clientConfigContext";

// TODO: find a type for props, policy and claim
export const RiskAssessment = () => {
  const config = useClientConfig();

  const [hazardsList, setHazardsList] = useState([] as Hazard[]);
  const [placeName, setPlaceName] = useState(config.defaultAddress);
  const [location, setLocation] = useState<LngLat>(
    new LngLat(config.defaultLocation[0], config.defaultLocation[1]),
  );
  const [buildingGeoJsonValueRiskTop, setBuildingGeoJsonValueRiskTop] = useState<GeoJsonData>(emptyGeojson);

  useEffect(() => {
    const currentHazards = getHazardsByUserAndPage(LocationRiskAssessment);
    setHazardsList(currentHazards);
  }, []);

  return (
    <HazardProvider>
      <Grid container spacing={1} style={{ marginTop: 15, height: "calc(100vh - 100px)" }}>
        <Grid item xs={12} md={6}>
          {/* <Box sx={{ height: { xs: "500px", sm: "500px", md: "calc(100vh - 100px)" } }}> */}
          <Box height={"100%"} minHeight={350}>
            {location ? (
              <RiskAssessmentMap
                buildingGeoJsonProp={buildingGeoJsonValueRiskTop}
                location={location}
                setLocation={setLocation}
                setPlaceName={setPlaceName}
              ></RiskAssessmentMap>
            ) : (
              <Grid container justifyContent="center">
                <CircularProgress />
              </Grid>
            )}
          </Box>
        </Grid>

        <Grid item xs={12} md={6}>
          {location && (
            <RiskRoofCard
              latitude={location.lat}
              longitude={location.lng}
              placeName={placeName}
              setBuildingGeoJsonValueSetter={setBuildingGeoJsonValueRiskTop}
            />
          )}

          {/* <Box
            style={{
              maxHeight: "780px", // Set the desired height
              // overflowY: "auto", // Enable vertical scrollbar
            }}
          > */}
          {location ? (
            <HazardsAssessmentWithTabs
              hazardsList={hazardsList}
              latitude={location.lat}
              longitude={location.lng}
            ></HazardsAssessmentWithTabs>
          ) : (
            <Grid container justifyContent="center">
              <CircularProgress />
            </Grid>
          )}
          {/* </Box> */}
        </Grid>
      </Grid>
    </HazardProvider>
  );
};
